import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const CenterListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const AddCenter = styled.button`
  background-color: transparent;
  border: 1px solid white;
  border-radius: 4px;
`;

export const OuterWrapper = styled.div`
  padding: 2rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const FilterFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom:30px;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  margin-bottom: 10px;
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  font-size: 14px;
`;

export const GridLoaderItem = styled.div`
  text-align: center;
`;

export const ProductContainer = styled.section`
  position: relative;
  width: 100%;
  box-shadow: 2px 2px 2px 2px rgb(0 0 0 / 20%);
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const ActionButtons = styled.div`
  justify-self: end;
`;

export const ButtonWrapper = styled.div`
  justify-self: end;
`;

export const CreateButton = styled(BaseButton)`
  background: #00aeea;
  border: 1px solid #00aeea;
  font-weight: normal;
  width: auto;
  font-size: 16px;
  font-family: lato;
  margin-bottom: 0px;
  line-height: 35px;
  margin-right: -1rem;
`;

export const BlockRow = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  padding: 0 10px;
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
}
`;

export const SliderGridRow = styled.div`
  display: grid;
  grid-template-columns:${(props) => props.column};
  gap: 1.25rem;
}
`;

export const TransportDetail = styled.div`
  font-size: 14px;
  font-style: italic;
  color: #767676 !important;
`;

export const FilterOuter = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 74%;
`;

export const GlobalSearch = styled.div`
  display: flex;
  align-items: center;
`;

export const CenterProductCount = styled.span`
  position: absolute;
  bottom: 10px;
  color: #767676;
  font-size: 14px;
  font-style: italic;
  right: 10px;
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
`;
